import React, { useState } from "react"
import { T } from "../../../traks"
import { Modal } from "reactstrap"
import BigText from "../../../c/BigText"

const DocumentModal = ({ isOpen, toggle, k, replace=[] }) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={toggle}
			className={"company_doc_modal"}
		>
			<BigText
				k={k}
				replace={replace}
			/>
		</Modal>
	)
}


const CompanyDocuments = ({company, ...props}) => {
	const [isOpen, setIsOpen] = useState(false)
	const [key, setKey] = useState("")
	const [replace, setReplace] = useState([])
	const className = "my-4 cursor_pointer primary_hover fw_500"

	const handleClickOnLink = (key, replace=[]) => {
		setKey(key)
		setIsOpen(true)
		if(replace.length){
			setReplace(replace)
		}
	}

	const bigTextReplace = [
		{dst: (company.name || ""), src: "__COMPANYNAME__"},
		{dst: (company.cvr || ""), src:"__CVR__"},
		{dst: (company.address || ""), src: "__ADDRESS__"},
		{dst: (company.zipcode || ""), src: "__ZIPCODE__"},
		{dst: (company.city || ""), src: "__CITY__"},
		{dst: (company.country || ""), src: "__COUNTRY__"},
		{dst: (new Date()).toDateString(), src: "__VALIDFROMDATE__"}
	]
	return (<>
		<div
			onClick={() => handleClickOnLink("privacy_policy")}
			className={className}
		>
			<T>Privacy Policy</T>
		</div>
		<div
			onClick={() => handleClickOnLink("whistleblower_policy", bigTextReplace)}
			className={className}
		>
			<T>Whistleblower policy</T>
		</div>
		<div
			onClick={() => handleClickOnLink("data_processing_agreement", bigTextReplace)}
			className={className}
		>
			<T>Data processing agreement</T>
		</div>
		<div
			onClick={() => handleClickOnLink("Written_guarantee_of_compliance_with_legal_requirements", bigTextReplace)}
			className={className}
		>
			<T>Written guarantee of compliance with legal requirements</T>
		</div>
		<div
			onClick={() => handleClickOnLink("article-30-register", bigTextReplace)}
			className={className}
		>
			<T>Article 30 register</T>
		</div>
		<DocumentModal
			isOpen={isOpen}
			toggle={() => setIsOpen(!isOpen)}
			k={key}
			replace={replace}
		/>
	</>)
}

export default CompanyDocuments
